<template>
  <div class="nfc-launch">
    <van-loading v-if="loading" size="24px" vertical color="#333">{{ loadingText }}</van-loading>
    <template v-else>
      <div class="nfc-launch__card">
        <h1 class="nfc-launch__title">{{ activityName || '打卡活动' }}</h1>
        <p v-if="isEnterpriseNfc" class="nfc-launch__subtitle">正在打开逻拓科技小程序活动页…</p>
        <p v-else class="nfc-launch__subtitle">请使用微信长按识别下方小程序码进入活动</p>
        <div v-if="!isEnterpriseNfc && qrImageUrl" class="nfc-launch__qrcode-wrap">
          <img
            class="nfc-launch__qrcode"
            :src="qrImageUrl"
            alt="活动小程序码"
          >
        </div>
        <p v-else-if="!isEnterpriseNfc && !qrImageUrl" class="nfc-launch__empty">活动小程序码尚未生成，请联系管理员在后台重新生成 NFC 地址</p>
        <p v-else-if="isEnterpriseNfc && errorMessage" class="nfc-launch__empty">{{ errorMessage }}</p>
        <p v-if="activityCode" class="nfc-launch__code">活动编码：{{ activityCode }}</p>
      </div>
    </template>
  </div>
</template>

<script>
import { getSignStoreActivityDetailByCode, getEnterpriseNfcRedirect } from '@/api/signstore'
import { getImageUrl } from '@/utils/image'
import { Toast } from 'vant'

/**
 * NFC 碰一碰中转页：
 * - 个人：展示太阳码，长按识别进小程序
 * - 逻拓科技（nfc=enterprise）：动态获取 URL Link 并自动跳转
 */
export default {
  name: 'NfcLaunch',
  data() {
    return {
      loading: true,
      loadingText: '加载中...',
      activityCode: '',
      activityName: '',
      qrImageUrl: '',
      isEnterpriseNfc: false,
      nfcEnv: 'release',
      errorMessage: ''
    }
  },
  mounted() {
    const code = this.$route.query.activity_code
      ? String(this.$route.query.activity_code).trim()
      : ''
    if (!code) {
      this.loading = false
      Toast('活动编码不存在')
      return
    }
    this.activityCode = code
    this.isEnterpriseNfc = String(this.$route.query.nfc || '').trim().toLowerCase() === 'enterprise'
    const env = this.$route.query.env ? String(this.$route.query.env).trim().toLowerCase() : 'release'
    this.nfcEnv = env === 'trial' ? 'trial' : 'release'
    if (this.isEnterpriseNfc) {
      this.redirectEnterpriseNfc()
    } else {
      this.loadPersonalActivity()
    }
  },
  methods: {
    async redirectEnterpriseNfc() {
      this.loading = true
      this.loadingText = '正在跳转小程序...'
      try {
        const res = await getEnterpriseNfcRedirect({
          activityCode: this.activityCode,
          env: this.nfcEnv
        })
        const data = res && res.data ? res.data : res
        const url = data && data.url ? String(data.url).trim() : ''
        if (!url) {
          throw new Error('未获取到跳转链接')
        }
        window.location.replace(url)
      } catch (e) {
        this.loading = false
        this.errorMessage = (e && e.message) || '跳转失败，请联系管理员检查 NFC 配置'
        Toast(this.errorMessage)
      }
    },
    async loadPersonalActivity() {
      this.loading = true
      try {
        const res = await getSignStoreActivityDetailByCode({ activityCode: this.activityCode })
        if (!res || res.status !== 200 || !res.data) {
          throw new Error((res && res.msg) || '获取活动信息失败')
        }
        const data = res.data
        this.activityName = data.activityName || ''
        const qr = data.qrCodeUrl ? String(data.qrCodeUrl).trim() : ''
        this.qrImageUrl = qr ? getImageUrl(qr) : ''
        if (!this.qrImageUrl) {
          Toast('小程序码尚未生成')
        }
      } catch (e) {
        Toast((e && e.message) || '加载失败')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="less">
.nfc-launch {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 16px;
  box-sizing: border-box;
  background: linear-gradient(180deg, #f0f4ff 0%, #f7f8fa 100%);
}

.nfc-launch__card {
  width: 100%;
  max-width: 360px;
  padding: 28px 20px 24px;
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 8px 24px rgba(15, 35, 95, 0.08);
  text-align: center;
}

.nfc-launch__title {
  margin: 0 0 12px;
  font-size: 20px;
  line-height: 1.4;
  font-weight: 600;
  color: #1a1a1a;
  word-break: break-word;
}

.nfc-launch__subtitle {
  margin: 0 0 20px;
  font-size: 14px;
  line-height: 1.5;
  color: #666;
}

.nfc-launch__qrcode-wrap {
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.nfc-launch__qrcode {
  width: 220px;
  height: 220px;
  object-fit: contain;
  border: 1px solid #eee;
  border-radius: 8px;
  background: #fff;
}

.nfc-launch__empty {
  margin: 0 0 16px;
  font-size: 14px;
  line-height: 1.6;
  color: #e6a23c;
}

.nfc-launch__code {
  margin: 0;
  font-size: 12px;
  color: #999;
  word-break: break-all;
}
</style>
